import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import TrialInstitutionIdentityContext from "src/contexts/data/TrialInstitutionIdentityContext";
import type { ILayoutSubMenu } from "src/contexts/layouts/LayoutContext";
import { createTrialInstitutionSubMenu } from "src/routing/navigation";

/**
 * Registers the trial institution submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Missing required identities yield no registration. Identity references control recomputation.
 */
const TrialInstitutionSubMenu: React.FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);
    const { data: trialInstitutionIdentity } = useContext(TrialInstitutionIdentityContext);

    const subMenu: ILayoutSubMenu = useMemo(
        () => {
            return createTrialInstitutionSubMenu(trialIdentity, trialInstitutionIdentity);
        },
        [trialIdentity, trialInstitutionIdentity]
    );

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default TrialInstitutionSubMenu;
